// this is to show the ALERT as MODAL
export const AlertForm = {
  OPEN_ALERT_MODAL: "OPEN_ALERT_MODAL",
  CLOSE_ALERT_MODAL: "CLOSE_ALERT_MODAL",
};
